<script lang="ts">
import { ComponentPublicInstance, defineComponent, inject, ref } from 'vue'

import { loaderInjectionKey } from '@/App.vue'
import MonogridLogo from '@/assets/svg/monogrid.svg'
import CtaPrimary from '@/components/atoms/CtaPrimary.vue'
import CtaSecondary from '@/components/atoms/CtaSecondary.vue'
import SiteMenu from '@/components/organisms/SiteMenu.vue'

export default defineComponent({
  name: 'SiteHeader',
  components: {
    CtaPrimary,
    CtaSecondary,
    MonogridLogo,
    SiteMenu
  },
  setup () {
    const menu = ref<ComponentPublicInstance<typeof SiteMenu>>()
    const loader = inject(loaderInjectionKey)

    return {
      menu,
      loader
    }
  }
})
</script>

<template>
  <header
    class="container-big fixed top-0 left-0 pt-5 grid grid-cols-2 items-center md:grid-cols-3"
    :class="{ 'opacity-0': !!loader ? loader.visible : true }"
  >
    <div v-if="$breakpoints.md">
      <CtaSecondary
        class="btn-contact"
        :to="{ name: 'Contact' }"
        icon-start="smiley"
        monospace
        scrambled
        @click="menu?.close()"
      >
        {{ $t('Contact_us') }}
      </CtaSecondary>
    </div>
    <div>
      <RouterLink :to="{ name: 'Home' }" @click="menu?.close()">
        <MonogridLogo class="logo md:mx-auto select-none" />
      </RouterLink>
    </div>
    <div class="text-right flex items-center justify-end gap-2">
      <CtaPrimary v-if="$breakpoints.md" green :to="{name: 'Works'}">
        {{ $t('Projects') }}
      </CtaPrimary>
      <SiteMenu ref="menu" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
header {
  z-index: $z-header;
  right: var(--scrollbar-placeholder);
  pointer-events: none;
  transition: opacity $ease-in-out-sine $default-duration $default-duration * 0.5;

  > * > * {
    pointer-events: auto;
  }
}

.logo {
  width: rem(130px);

  @screen md {
    width: rem(180px);
  }
}

.btn-contact {
  ::v-deep(svg) {
    transform: rotate(0);
  }

  @include hover {
      &:hover {
        ::v-deep(svg) {
          transform: rotate(360deg);
          transition: transform 0.5s ease-in-out;

          @include motion-reduce {
            transition-duration: 0s;
          }
        }
    }
  }
}
</style>
